import { app, cart, combo, utilities } from 'core/use-cases';

import { validateShippingModel } from '../../helpers';

import { loading, messages } from './tasks';
import { getLocationPathname } from 'core/utilities';

/**
 * Broker responsible for handling the request flow.
 *
 */
export function* requestFlow(action: utilities.ActionSuccess) {
  const requestEventTypes = Object.keys(messages.request);
  if (requestEventTypes.includes(action.type)) {
    if (
      action.type === combo.actions.comboPost.request.type ||
      action.type === cart.actions.itemAddFetch.request.type
    ) {
      const isShippingModel: boolean = yield validateShippingModel();

      if (isShippingModel) {
        yield app.actions.toggleShipping(false);

        return;
      }

      yield loading.setLoading(action);

      return;
    }

    if (action.type === cart.actions.cartFetch.request.type) {
      const pathname: string = getLocationPathname();

      if (
        pathname.includes('/confirmation') ||
        pathname.includes('/process-error') ||
        pathname.includes('/40') ||
        pathname.includes('/50')
      ) {
        return;
      }
    }

    yield loading.setLoading(action);
  }
}
